import Loadable from '../../components/loadable';

const GeneralKioskAttendancesReport = Loadable({
  loader: () => import('../../pages/reports/general_kiosk_attendances_report'),
});

angular.module('gym').value('GeneralKioskAttendancesReport', GeneralKioskAttendancesReport);
